import type { Dispatch } from 'react';
import { useState } from 'react';
import type { Instance } from 'tippy.js';

interface UseTippy {
  set: Dispatch<Instance | null>;
  get: () => Instance | null;
  toggle: () => void;
  close: () => void;
  open: () => void;
}

export function useTippy(): UseTippy {
  const [instance, setInstance] = useState<Instance | null>(null);

  const toggle = () => {
    if (instance?.state.isVisible === true) {
      instance?.hide();
    } else {
      instance?.show();
    }
  };

  const close = () => instance?.hide();
  const open = () => instance?.show();
  const get = () => instance;

  return { set: setInstance, get, toggle, close, open };
}
